export default function mapQuestionnaireResponse(questionnaire, response) {
    const responseMap = new Map();

    // Helper function to find questionnaire item by linkId using array methods
    function findQuestionnaireItem(linkId, items) {
        return items.reduce((acc, item) => {
            if (acc) return acc;
            if (item.linkId === linkId) {
                return item;
            }
            if (item.item) {
                return findQuestionnaireItem(linkId, item.item);
            }
            return null;
        }, null);
    }

    function extractItems(item) {
        const questionnaireItem = findQuestionnaireItem(item.linkId, questionnaire.item);
        if (item.answer) {
            responseMap.set(item.linkId, extractAnswer(item.answer, questionnaireItem?.repeats));
        }
        if (item.item) {
            item.item.forEach(extractItems);
        }
    }

    function extractAnswer(answers, repeats) {
        return repeats ? answers.map(answer => extractValue(answer)) : extractValue(answers[0]);
    }

    function extractValue(answer) {
        return (
            answer.valueDate ||
            answer.valueString ||
            answer.valueCoding?.code ||
            answer.valueBoolean ||
            answer.valueInteger ||
            answer.valueDecimal ||
            answer.valueAttachment
        );
    }

    // Initialize the response map
    response.item.forEach(extractItems);

    function findAnswers(questionnaireItem) {
        const result = {};
        if (questionnaireItem.linkId && responseMap.has(questionnaireItem.linkId)) {
            result[questionnaireItem.linkId] = responseMap.get(questionnaireItem.linkId);
        }
        if (questionnaireItem.item) {
            questionnaireItem.item.forEach(childItem => {
                Object.assign(result, findAnswers(childItem));
            });
        }
        return result;
    }

    return questionnaire.item.flatMap(findAnswers).reduce((acc, curr) => ({ ...acc, ...curr }), {});
}
